
<footer class="footer footer-static footer-light navbar-border navbar-shadow">
  <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
      <span class="float-md-left d-block d-md-inline-block">Copyright &copy; {{ currentYear }} <a class="text-bold-800 grey darken-2" href="https://www.icashremit.com"
                                                                                     target="_blank"> ICASHREMIT</a>,&nbsp;All rights reserved. </span>

  </p>
</footer><!-- BEGIN VENDOR JS-->
